import { render, staticRenderFns } from "./MessageDetailsCard.vue?vue&type=template&id=00fdf852&scoped=true&"
import script from "./MessageDetailsCard.vue?vue&type=script&lang=js&"
export * from "./MessageDetailsCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00fdf852",
  null
  
)

export default component.exports